var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentType === 'arrow' ? 'ArrowLink' : 'Button',_vm._b({tag:"Button",staticClass:"c_link_field",class:{ 'c_button_2022 c_button_2022__primary': _vm.buttonAttrs?.styling === 'default2023' },on:{"onClick":_vm.clickThroughAction}},'Button',_vm.buttonAttributes,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }